import { Store } from "@/custom-types/Store";

export const isPlatinum = (premiumRank?: Store["premiumRank"]) => {
  return !!(
    premiumRank &&
    ["diamond", "platinum", "gold", "silver", "bronze"].includes(premiumRank)
  );
};
